<template>
  <div id="about">
      <br />
      <h2>Channel is building a composable media network for the creator communities of the future.</h2>
      <p>
        We saw potential in building a web3 media organization in early 2021 when we set out to rethink the infrastructure of digital media—prioritizing portable, interoperable, and durable communities.
      </p>
      <p>
        In 2022, fully community funded and in collaboration with engineers, creators, and thinkers, we started building a toolset that enables collective on-chain broadcasting via token-enabled RSS.
      </p>
      <p>
        We’ve focused on podcast support first because we believe it’s an undervalued medium. Podcasts are not just growing rapidly, they are highly influential as a beacon for growing extraordinarily generative communities. But their creators, tied to subpar platforms, are struggling to realize the deep value that the relationships to and among their audiences holds. Podcasts first, with a media-agnostic content distribution core.
      </p>
      <p>
        Channel launched with the bundled content of its founding creators: Interdependence, Joshua Citarella and New Models, which can be accessed through our <a href="https://www.gem.xyz/collection/channel-s0/">inaugural S0 Founder Tokens</a>.
      </p>
      <p>
       Connect your wallet and listen to exclusive new content and <a href="https://channel.xyz">archived episodes</a>—and stay tuned for further developments, including new tools, exclusive content, and expanded access to additional creators in 2023.
      </p>
      <p>
        For any inquiries join our <a href="https://discord.com/invite/channelxyz">Discord</a> or DM us <a href="https://twitter.com/channel">@channel</a> on Twitter.
      </p>
      <br />
      <hr>
      <br />
      <br />
      <div class="flex">
        <div class="w-half">
          <h3>Team</h3>
        </div>
        <div class="w-half">
          <p>
            <strong>Co-Founder and CEO</strong>
            <br/><a href="https://twitter.com/dnlklr">Daniel Keller</a>
          </p>
          <p>
            <strong>Technical Advisor</strong>
            <br /><a href="https://twitter.com/cullenmiller">Cullen Miller</a>
          </p>
          <p>
            <strong>Founding Creators</strong>
            <br /><a href="https://twitter.com/hollyherndon">Holly Herndon</a> + <a href="https://twitter.com/matdryhurst"><nobr>Mat Dryhurst</nobr></a> (<a href="https://twitter.com/1nterdependence">Interdependence</a>);
            <br /><a href="https://twitter.com/cbcb2000">Caroline Busta</a> + <a href="https://twitter.com/LILINTERNET"><nobr>Lil Internet</nobr></a> (<a href="https://twitter.com/newmodels_io">New Models</a>);
            <br /> <a href="https://twitter.com/joshuacitarella">Joshua Citarella</a> <nobr>(<a href="https://donotresearch.net/">Do Not Research</a>)</nobr>
          </p>
        </div>
      </div>
  </div>
</template>

<script>
export default {
    name: "About"
};
</script>

<style scoped>
  .flex {
    display: flex;
  }

  .w-half {
    width: 50%;
  }

  #about {
    max-width: 800px;
    margin: 3em auto 0 auto;
    padding: 0 5%;
  }
</style>
